<template>
  <section>
    <div class="mui-content">
      <div class="title-name">
        <span class="">标签补打</span>
      </div>
      <div style="margin-top: 25px;">
        <div class="form-group">
          <div class="input-label">
            <label>当前供应商:</label>
          </div>
          <div class="form-input">
            <input type="text" v-model="ksmc" readonly>
          </div>
        </div>
      </div>
      <div>
        <div class="sampling-first-title">
          <h4 style="padding-left: 15px;">基础信息</h4>
        </div>
        <div class="form-group">
          <div class="input-label">
            <label>物料:</label>
          </div>
          <div class="form-input">
            <div style="width: 85%;margin-bottom: 15px;">
               <multiselect v-model="wphinfo" :options="scxtwpLst" :close-on-select="true" placeholder="请输入物料"  label="dipname" 
                  track-by="scxtwph" @select="wphSelected" :multiple="false" :showLabels="false" :allowEmpty="false">
                </multiselect>
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="input-label">
            <label>外注订单:</label>
          </div>
          <div class="form-input">
            <select v-model="orderinfo">
              <option v-for="item in orderLst" :value="item">{{item.ddh}}</option>
            </select>
          </div>
        </div>
        <div class="form-group">
          <div class="input-label">
            <label v-if="orderinfo&&orderinfo.ddqf=='3'">反番号:</label>
            <label v-else>外注卷号:</label>
          </div>
          <div class="form-input">
            <input type="text" v-model="wzrollno" @blur.prevent="toUpperCase('wzrollno')">
          </div>
        </div>
        <div class="form-group">
          <div class="input-label">
            <label>TSD卷号:</label>
          </div>
          <div class="form-input">
            <input type="text" v-model="tsdrollno" @blur.prevent="toUpperCase('tsdrollno')">
          </div>
        </div>
        <div class="form-group" style="width:100%;margin-top: 30px;">
          <button type="button" class="mui-btn mui-btn-primary btn-blue" style="margin: auto;min-width: 80px;" @tap="search" >查询</button>
        </div>
      </div>
    </div>
  </section>
</template>


<script>
import Vue from 'vue'
import Multiselect from 'vue-multiselect'

export default {
  name: "label",
  components: { 
    Multiselect 
  },
  data() {
    return {
      ksbh: "",       // 当前供应商编号
      ksmc: "",       // 当前供应商名称
      scxtwpLst: [],  // 生产ERP物料列表
      wphinfo: null,  // 选择的物料（默认生产ERP物料列表的第一项）
      orderLst: [],   // 外注订单列表
      orderinfo:null, // 选择的外注订单（默认外注订单列表的第一项）
      wzrollno: "",   // 外注坯布卷号
      tsdrollno: "",  // TSD坯布卷号
    }
  },
  created() {
    this.getKsbh();
    //this.nyy.wxInit();
  },
  activated() {},
  watch: {
    wzrollno: function(val) {
      this.wzrollno = (val).toUpperCase();
    },
    tsdrollno: function(val) {
      this.tsdrollno = (val).toUpperCase();
    }
  },
  methods: {
    // 获取当前供应商编号、名称、是否TSD自家工厂
    getKsbh() {
      var v = this;
      v.nyy.doPost("/Quality/getKsbh", {},
        function(result) {
          if (result.status) {
            v.ksbh = result.data.ksbh;
            v.ksmc = result.data.ksmc;
            v.isTSD = result.data.isTSD;
            v.getScxtwpLst();
          }
        }
      );
    },
    // 获取物料（生产ERP品号、生产ERP名称、物料代码、dipname)列表
    getScxtwpLst() {
      var v = this;
      v.nyy.doPost("/Quality/getScxtwpLst", { islabelPrt:"true" },
        function(result) {
          if (result.status) {
            v.scxtwpLst = result.data.infoLst;
            v.wphinfo = null;
            if(v.scxtwpLst && v.scxtwpLst.length>0){
              v.wphinfo = v.scxtwpLst[0];
              v.getOrderLst();
            }
          }
        }
      );
    },
    // 获取外注订单列表
    getOrderLst() {
      var v = this;
      var wph = v.wphinfo ? v.wphinfo.wph : "";
      v.nyy.doPost("/Quality/getOrderLst", { ksbh: v.ksbh, wph: wph, islabelPrt:"true" },
        function(result) {
          if (result.status) {
            v.orderLst = result.data.infoLst;
            v.orderinfo = null;
            if(v.orderLst && v.orderLst.length>0){
              v.orderinfo = v.orderLst[0];
            }
          }
        }
      );
    },
    // 选中事件
    wphSelected(selectedOption, id) {
      var v = this; 
      v.wphinfo = selectedOption;
      v.getOrderLst();    // 重新获取外注订单列表
    },
    // 跳转到一览页面，查询和展示坯布卷列表
    search() {
      var v = this;
      // 物料
      var wph = v.wphinfo ? v.wphinfo.wph : "";
      // 外注订单
      var ddh = v.orderinfo ? v.orderinfo.ddh : "";
      if (wph == "") {
        mui.toast("请选择物料");
        return;
      }

      if (ddh == "") {
        mui.toast("请选择外注订单");
        return;
      }

      // 外注卷号和TSD卷号二者必填一个校验
      if (v.nyy.isEmpty(v.wzrollno) && 
          v.nyy.isEmpty(v.tsdrollno)) {
        mui.toast("请输入外注卷号或TSD卷号，两者不能全部为空！");
        return;
      }

      // 转到查询一览页面
      var para_info = { 
        "ksbh": v.ksbh, 
        "wph": v.wphinfo ? v.wphinfo.wph : "", 
        "ddh": v.orderinfo ? v.orderinfo.ddh : "", 
        "wzrollno": v.wzrollno, 
        "tsdrollno": v.tsdrollno 
      };
      v.$router.push({ 
        "name": "labelOrders", 
        params: jsonPara(para_info) 
      });
    },
    // 返回一个字符串，该字符串中的所有字母都被转化为大写字母
    toUpperCase(name){
      var v = this;
      if(name == 'wzrollno'){
        v.wzrollno = (v.wzrollno).toUpperCase();
      }else if(name == 'tsdrollno'){
        v.tsdrollno = (v.tsdrollno).toUpperCase();
      }
    },
  }
}
</script>

<style src="../../static/css/vue-multiselect.min.css"></style>
<style scoped>
@import "../../static/css/samplinghistory.css";
@import "../../static/css/filterorder.css";
.multiselect__input{
   border:none;
}
.multiselect__single{
  white-space: nowrap;
  overflow:hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/label.vue